import {
  ALARMCONFIGLIST,
  } from '../actions/alarmConfiguration';
  import {reducerPackage} from "../../utils";
  
  export const alarmConfiguration = reducerPackage(ALARMCONFIGLIST);
  